const setPageTitle = (route, path) => {
  const curTitle = route.find((item) => item.path === path.pathname)
  if (curTitle && curTitle.title) {
    const page_title = process.env.REACT_APP_NAME + ' - ' + curTitle.title
    document.title = page_title
  }
}
export { setPageTitle }
